module.exports = __webpack_public_path__ + "56ad70b3cfa875d254216f06c1e38c88.MP3";